import type { RouteRecordRaw } from 'vue-router'

export const authRouteName = {
  signup: 'Signup',
  login: 'Login',
} as const

const routes: RouteRecordRaw[] = [
  {
    component: () => import('src/components/Auth/Login/index.vue'),
    name: authRouteName.login,
    path: '/login',
    meta: { isOutsideApp: true, title: 'Login' },
  },
  {
    component: () => import('src/components/Auth/Logout/index.vue'),
    name: 'Logout',
    path: '/logout',
  },
  {
    component: () => import('src/components/Auth/Signup/index.vue'),
    name: authRouteName.signup,
    path: '/signup',
    meta: { isOutsideApp: true, title: 'Signup' },
  },
  {
    component: () => import('src/components/Auth/SSOLogin/index.vue'),
    name: 'SSOLoginPage',
    path: '/sso-login',
    meta: { isOutsideApp: true, keepRoute: true, title: 'SSO Login' },
  },
  {
    component: () => import('src/components/Auth/ResendConfirmation/index.vue'),
    name: 'ResendConfirmation',
    path: '/confirm/resend',
    meta: { isOutsideApp: true, title: 'Resend Confirmation' },
  },
  {
    component: () => import('src/components/Auth/ForgotPassword/index.vue'),
    name: 'ForgotPassword',
    path: '/forgot-password',
    meta: { isOutsideApp: true, title: 'Forgot Password' },
  },
  {
    component: () => import('src/components/Auth/ResetPassword/index.vue'),
    name: 'ResetPassword',
    alias: ['/reset_password/:token'],
    path: '/reset-password/:token',
    meta: { isOutsideApp: true, keepRoute: true, title: 'Reset Password' },
  },
  {
    component: () => import('src/components/Auth/AcceptInvitation/index.vue'),
    name: 'AcceptInvitation',
    path: '/accept/:id',
    meta: { isOutsideApp: true, keepRoute: true, title: 'Accept Invitation' },
  },
  {
    component: () => import('src/components/Auth/ConfirmAccount/index.vue'),
    name: 'ConfirmAccount',
    path: '/confirm/:token',
    meta: { isOutsideApp: true, keepRoute: true, title: 'Confirm Account' },
  },
  {
    component: () => import('src/components/Auth/SSOAuth/index.vue'),
    name: 'SSOAuth',
    path: '/sso/:token',
    meta: { isOutsideApp: true, keepRoute: true, title: 'SSO Auth' },
  },
]

export default routes
